import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { mcaI20Logo } from "../../Assets";
import { useAuthStore } from "../../store";
import { getTeamDetails } from "../../Utils/apiService";
import { formatToIndianCurrencyWords2 } from "../../Utils/helperFunctions";
import TeamSquadList from "./components/TeamSquadList";

const SquadList = () => {
  const [teamDetails, setTeamDetails] = useState<any>();
  const { teamDetailsTrigger, liveTeamId } = useAuthStore();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [teamsRes] = await Promise.all([getTeamDetails()]);

        if (teamsRes?.data?.success) {
          const teams = teamsRes?.data?.data || [];

          const enrichedTeams = teams.map((team: any) => {
            const records = team?.Player_Registrations__r?.records || [];

            const enrichedRecords = records.map((record: any) => {
              return {
                ...record,
                playerId:
                  record?.playerId ??
                  record?.Player__c ??
                  record?.Player__r?.Id ??
                  record?.Player__r?.playerId,
                playerAge:
                  record?.playerAge ??
                  record?.Player_Age__c ??
                  record?.Age__c ??
                  record?.Player__r?.Player_Age__c,
                birthData:
                  record?.birthData ??
                  record?.Birth_Date__c ??
                  record?.Date_of_Birth__c ??
                  record?.Player__r?.Birth_Date__c ??
                  record?.Player__r?.Date_of_Birth__c,
                MCANo:
                  record?.MCANo ??
                  record?.MCA_Registration_Number__c ??
                  record?.MCA_No__c ??
                  record?.Player__r?.MCA_Registration_Number__c ??
                  record?.Player__r?.MCA_No__c,
              };
            });

            return {
              ...team,
              Player_Registrations__r: {
                ...team?.Player_Registrations__r,
                records: enrichedRecords,
              },
            };
          });

          setTeamDetails(enrichedTeams);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };

    fetchData();
  }, [teamDetailsTrigger]);

  const teamDetailsData = teamDetails?.find(
    (team: any) => team?.Id === liveTeamId,
  );
  const squadRecords = teamDetailsData?.Player_Registrations__r?.records;

  if (!squadRecords?.length) {
    return (
      <Box
        sx={{
          width: "100%",
          minHeight: "100vh",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            width: "100%",
            mt: 0,
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: { xs: 2, md: "1.2vw" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: { xs: 1.2, md: "1vw" },
              width: "100%",
              maxWidth: "62vw",
            }}
          >
            <img
              src={mcaI20Logo}
              alt="T20 Mumbai"
              style={{
                width: "18vw",
                maxWidth: "18vw",
                minWidth: "10vw",
                height: "auto",
                objectFit: "contain",
                flexShrink: 0,
              }}
            />
            <Typography
              sx={{
                color: "#fff",
                fontWeight: 800,
                fontSize: { xs: "2rem", md: "3vw" },
                lineHeight: 1,
                textAlign: "left",
                whiteSpace: "nowrap",
              }}
            >
              T20 Mumbai League - 2026
            </Typography>
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "95vh",
        position: "relative",
        display: "flex",
        alignItems: "stretch",
        py: { xs: 1.5, md: "1vw" },
      }}
    >
      <Box
        sx={{
          width: "100%",
          minHeight: "100%",
          display: "flex",
          flexDirection: "column",
          pt: { xs: 1.5, md: "1vw" },
          px: { xs: 2.2, md: "1.2vw" },
          pb: { xs: 2, md: "0.8vw" },
        }}
      >
        <Box
          sx={{
            border: "1px solid rgba(255, 124, 24, 0.3)",
            background:
              "linear-gradient(90deg, rgba(50,19,5,0.96) 0%, rgba(110,42,2,0.95) 70%, rgba(227,116,16,0.95) 100%)",
            p: { xs: 1.2, md: "0.55vw" },
            position: "relative",
            mb: { xs: 2, md: "0.8vw" },
            display: "flex",
            alignItems: "center",
            gap: { xs: 1.2, md: "0.7vw" },
            "&::after": {
              content: '""',
              position: "absolute",
              left: 0,
              right: 0,
              bottom: -4,
              height: "4px",
              background:
                "linear-gradient(90deg, #e41f4f 0%, #e41f4f 12%, #24c864 12%, #24c864 26%, #1ba8ff 26%, #1ba8ff 40%, #4e5dff 40%, #4e5dff 54%, #ff8b1a 54%, #ff8b1a 67%, #ff3e4d 67%, #ff3e4d 79%, #ffd400 79%, #ffd400 90%, #22d37b 90%, #22d37b 100%)",
            },
          }}
        >
          <img
            src={teamDetailsData?.Logo_URL__c}
            alt="team"
            style={{
              width: "3.4vw",
              height: "3.4vw",
              minWidth: 58,
              minHeight: 58,
              objectFit: "contain",
              flexShrink: 0,
            }}
          />

          <Typography
            sx={{
              fontWeight: 800,
              fontStyle: "italic",
              fontSize: { xs: "1.7rem", md: "2.1vw" },
              lineHeight: 1,
              background:
                "linear-gradient(90deg, #FF8C1E 0%, #FF3E9A 47%, #4B5BFF 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            {teamDetailsData?.Name?.toUpperCase()}
          </Typography>
          <Typography
            sx={{
              fontWeight: 800,
              fontStyle: "italic",
              fontSize: { xs: "1.7rem", md: "2.1vw" },
              lineHeight: 1,
              background:
                "linear-gradient(90deg, #FF6B39 0%, #FF3E9A 55%, #7650FF 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            {`- ${(teamDetailsData?.Team_Type__c || "").toUpperCase()} SQUAD LIST`}
          </Typography>

          <Box
            sx={{
              ml: "auto",
              px: { xs: 1.2, md: "0.8vw" },
              py: { xs: 0.6, md: "0.45vw" },
              border: "1px solid rgba(255, 255, 255, 0.22)",
              background: "rgba(0, 0, 0, 0.28)",
              display: "flex",
              alignItems: "center",
              gap: { xs: 0.8, md: "0.45vw" },
              whiteSpace: "nowrap",
            }}
          >
            <Typography
              sx={{
                color: "rgba(255, 255, 255, 0.8)",
                fontWeight: 700,
                fontSize: { xs: "0.75rem", md: "0.75vw" },
                lineHeight: 1,
                textTransform: "uppercase",
              }}
            >
              Fund Remaining
            </Typography>
            <Typography
              sx={{
                color: "#fff",
                fontWeight: 800,
                fontSize: { xs: "1rem", md: "1.05vw" },
                lineHeight: 1,
              }}
            >
              {formatToIndianCurrencyWords2(teamDetailsData?.Fund_Remaining__c)}
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            background:
              "linear-gradient(180deg, rgba(18, 7, 15, 0.55) 0%, rgba(8, 8, 12, 0.52) 100%)",
            border: "1px solid rgba(255,255,255,0.08)",
            flex: 1,
            px: { xs: 1.4, md: "1vw" },
            pr: { xs: 2, md: "2.5vw" },
            py: { xs: 1.8, md: "0.9vw" },
          }}
        >
          <Box
            sx={{
              width: "100%",
              p: { xs: 2, md: "0.8vw" },
            }}
          >
            <TeamSquadList
              teamDetailsData={squadRecords}
              division={
                String(teamDetailsData?.Team_Type__c || "")
                  .toLowerCase()
                  .includes("women")
                  ? "women"
                  : "men"
              }
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default SquadList;
